import { useCompanyStore } from "~/stores";
import CheckboxSmall from "~/ui/Checkbox/CheckboxSmall";

interface ICompanyItem {
    companyId: number;
    isSelected: boolean;
    btnClickCallback: (isSelected: boolean, id: number) => void;
}

const CompanyItem = (props: ICompanyItem) => {
    const { companyId, isSelected, btnClickCallback } = props;

    const getCompanyById = useCompanyStore(state => state.getCompanyById);
    const companyData = getCompanyById(companyId);

    if (!companyData) return;

    const { id, name } = companyData;

    return (
        <CheckboxSmall
            className="flex items-center w-full h-9 text-sm text-stone-darkest font-medium-light tracking-[-0.28px] hover:text-stone-darkest gap-x-2"
            aria-labelledby={name}
            onChange={isSelectedValue => btnClickCallback(isSelectedValue, id)}
            isSelected={isSelected}
        >
            {name}
        </CheckboxSmall>
    );
};

export default CompanyItem;
